import React from "react";
import "./css/Spacer.css";

const Spacer = ({ id }) => <div id={id} className="spacer"></div>;

export default Spacer;
